import React, { useEffect } from 'react';

import { FILLOUT } from 'constants/UrlConstants';

import { removeScript } from 'helpers/DOM';

import clsx from 'clsx';

import styles from './GetStartedButton.module.css';

const GetStartedButton = (props) => {
    useEffect(() => {
        if (__isBrowser__) {
            const script = document.createElement('script');
            script.src = FILLOUT;
            script.defer = true;
            document.body.appendChild(script);
        }
        return () => removeScript(FILLOUT);
    }, []);

    const containerClass = clsx(styles.buttonBase, {
        [styles.buttonNavButton]: props.isNavButton,
        [styles.buttonDarkPage]: props.promoDarkPage,
        [styles.buttonFixedHeader]: props.fixedHeader,
        [styles.buttonMobileMenu]: props.isMobileMenu,
        [styles.buttonFixedButton]: props.fixedButton,
    });

    return (
        <div className={containerClass}>
            <div
                data-fillout-id="5ZKN62yiNZus"
                data-fillout-embed-type="popup"
                data-fillout-button-text={props.buttonText}
                data-fillout-dynamic-resize
                data-fillout-inherit-parameters
                data-fillout-popup-size="medium"
            />
        </div>
    );
};

export default GetStartedButton;
